import { Activity } from "@/components/dashboard/resent_activities/Activity"
import { useRecentActivities } from "@usher/pe-client-front-end-lib"
import { FormattedMessage } from "react-intl"
import { NavLink } from "react-router-dom"
import Scrollbars from "simplebar-react"

export const RecentActivities = () => {
  const { data } = useRecentActivities()

  return (
    <div className="markets-wallets">
      <div className="markets-wallets__title-wrap d-flex mb-xs">
        <h3 className="h3 markets-actions__title">
          <FormattedMessage id="recent_activities" />
        </h3>
        <NavLink to="/transactions/exchange" className="button-reset personal-information-box__title-modal-btn">
          <FormattedMessage id="show" />
        </NavLink>
      </div>
      <div className="table-scroll table-scroll__activities mt-3">
        <Scrollbars style={{ height: "100%" }}>
          <div className="box box-light activities-box my-wallets">
            {data.map((activity, key) => (
              <Activity key={key} activity={activity} />
            ))}
          </div>
        </Scrollbars>
      </div>
    </div>
  )
}
